// extracted by mini-css-extract-plugin
export default {"container":"a1O8Os","scrollBarColor":"iM2jMk","cardContainer":"Ubk1UG","listContainer":"AjaWjx"};